// extracted by mini-css-extract-plugin
module.exports = {"container_footer":"footer_container_footer__1gcnM"};